import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { StyledContainer } from './styled.js';
import { ContainerLayout } from './types.js';
export { ContainerLayout };
export const Container = memo(forwardRef(function Container({ fluid, layout, children, className, dataTestId, spacer }, ref) {
    return (_jsx(StyledContainer, { ref: ref, $fluid: fluid, $layout: layout, $spacer: spacer, className: className, "data-testid": dataTestId, children: children }));
}));
